import { useSession } from '@/client/lib/auth'
import { Navigate } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Protected route wrapper
 *
 * Redirects to sign-in if user is not authenticated
 * Shows loading state while checking session
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { data: session, isPending } = useSession()

  // Initial cold-load: session unknown AND nothing cached. Show a quiet null
  // (brief blank) rather than a full-page spinner that wipes the layout chrome.
  // After the first resolution useSession returns the cached session and this
  // branch never fires again — so route transitions keep the sidebar/header
  // visible instead of replacing the entire app with "Loading...".
  if (isPending && !session) {
    return null
  }

  if (!session) {
    return <Navigate to="/sign-in" replace />
  }

  return <>{children}</>
}
